<template>
  <div class="modal-overlay">
    <div class="modal-content">
      <div class="success-icon">
        <vue-feather type="check-circle" size="64" class="icon"></vue-feather>
      </div>

      <h1>Payment Successful!</h1>
      <p class="message">Your credits have been added to your account.</p>

      <!-- Purchase Details Section -->
      <div class="summary-section">
        <h2>Purchase Details</h2>
        <div class="summary-row">
          <span>Credits Added</span>
          <span>{{ credits }} credits</span>
        </div>
        <div class="summary-row">
          <span>Reference ID</span>
          <span>{{ referenceId }}</span>
        </div>
      </div>

      <div class="action-buttons">
        <button class="return-btn" @click="goHome">Back to Bookings</button>
        <button class="close-btn" @click="$emit('close')">Close</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PaymentSuccessModal",
  props: {
    credits: {
      type: Number,
      required: true,
    },
    referenceId: {
      type: String,
      required: true,
    },
  },
  methods: {
    goHome() {
      this.$router.push("/");
    },
  },
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  background: white;
  padding: 2rem;
  border-radius: 12px;
  width: 90%;
  max-width: 500px;
  max-height: 90vh;
  overflow-y: auto;
  text-align: center;
}

.success-icon {
  margin-bottom: 1.5rem;
}

.icon {
  color: #10b981; /* Green color for success */
}

h1 {
  font-size: 24px;
  font-weight: 600;
  margin-bottom: 0.5rem;
  color: #111827;
}

.message {
  font-size: 16px;
  color: #6b7280;
  margin-bottom: 1.5rem;
}

h2 {
  font-size: 18px;
  font-weight: 500;
  margin-bottom: 1rem;
  color: #374151;
  text-align: left;
}

.summary-section {
  background-color: #f9fafb;
  padding: 1.5rem;
  border-radius: 8px;
  margin-bottom: 1.5rem;
  text-align: left;
}

.summary-row {
  display: flex;
  justify-content: space-between;
  margin-bottom: 0.5rem;
  font-size: 14px;
  color: #6b7280;
}

.action-buttons {
  display: flex;
  gap: 1rem;
}

.return-btn,
.close-btn {
  flex: 1;
  padding: 0.75rem;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;
}

.return-btn {
  background-color: #000;
  color: white;
}

.return-btn:hover {
  background-color: #1a1a1a;
}

.close-btn {
  background-color: #f3f4f6;
  color: #111827;
}

.close-btn:hover {
  background-color: #e5e7eb;
}
</style>
